import { Box, Flex, Typography } from "@jewlr/storybook/core"
import { FloatSelect, FloatInput } from "@jewlr/storybook/form"
import PropTypes from "prop-types"
import React from "react"
import { Controller } from "react-hook-form"

import { InputWrapper } from "areas/order/components"
import { jewlr_t } from "helpers/application"
import { useGoogleAutocomplete } from "helpers/use-google-autocomplete"

const ShipAddress = ({ control, country, setValue, subregions, watch }) => {
  const { setRef: setGoogleAutocompleteRef } = useGoogleAutocomplete({
    country,
    enableCountryCheck: true,
    setValue,
    watch,
  })

  return (
    <>
      <Typography fontSize="20px" fontWeight="500" lineHeight="20px" mb={2}>
        Change Your {jewlr_t("terms.Shipping")} Address to:
      </Typography>
      <Flex flexDirection={{ _: "column", desktop: "row" }}>
        <Box mr={{ desktop: 2 }}>
          <InputWrapper>
            <Controller
              control={control}
              name="address1"
              render={({ field: { ref, ...rest }, fieldState: { error } }) => (
                <FloatInput
                  autoComplete="change-shipping-address address1"
                  data-cy="change-shipping-address-address1"
                  error={error}
                  label="Street Address"
                  placeholder="Street Address"
                  type="text"
                  variant="checkout"
                  {...rest}
                  ref={(e) => {
                    if (setGoogleAutocompleteRef) {
                      setGoogleAutocompleteRef(e)
                    }
                    ref(e)
                  }}
                />
              )}
            />
          </InputWrapper>
          <InputWrapper>
            <Controller
              control={control}
              name="city"
              render={({ field, fieldState: { error } }) => (
                <FloatInput
                  {...field}
                  error={error}
                  label={jewlr_t("address.city")}
                  placeholder={jewlr_t("address.city")}
                  type="text"
                  variant="checkout"
                />
              )}
            />
          </InputWrapper>
          <InputWrapper>
            <Controller
              control={control}
              name="postal_code"
              render={({ field, fieldState: { error } }) => (
                <FloatInput
                  {...field}
                  data-cy="change-shipping-address-postal_code"
                  error={error}
                  label={jewlr_t("address.zip")}
                  placeholder={jewlr_t("address.zip")}
                  type="text"
                  variant="checkout"
                />
              )}
            />
          </InputWrapper>
        </Box>
        <Box>
          <InputWrapper>
            <Controller
              control={control}
              name="address2"
              render={({ field, fieldState: { error } }) => (
                <FloatInput
                  {...field}
                  error={error}
                  label="Building, Apartment, Suite, Unit #"
                  placeholder="Building, Apartment, Suite, Unit #"
                  type="text"
                  variant="checkout"
                />
              )}
            />
          </InputWrapper>
          <InputWrapper>
            <Controller
              control={control}
              name="state"
              render={({ field, fieldState: { error } }) => (
                <>
                  {subregions ? (
                    <>
                      <FloatSelect
                        {...field}
                        autoComplete="address-change state"
                        error={error}
                        label={jewlr_t("address.state")}
                        name="state"
                        onChange={(e) => {
                          field.onChange(e.target.value)
                        }}
                        placeholder={jewlr_t("address.state")}
                      >
                        <option value="">
                          Select {jewlr_t("address.state")}
                        </option>
                        {subregions.map((subregion) => (
                          <option key={subregion[0]} value={subregion[0]}>
                            {subregion[1]}
                          </option>
                        ))}
                      </FloatSelect>
                    </>
                  ) : (
                    <input type="hidden" {...field} />
                  )}
                </>
              )}
            />
          </InputWrapper>
        </Box>
      </Flex>
    </>
  )
}

ShipAddress.propTypes = {
  control: PropTypes.object,
  country: PropTypes.string,
  setValue: PropTypes.func,
  subregions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  watch: PropTypes.func,
}

export default ShipAddress
